const texts = {
  filterOptions: {
    ALL: 'All',
    CHECK_INS: 'Check-in Submissions',
    LEADS: 'Lead Activities',
    ONBOARDING: 'Onboarding Activities',
    PAYMENTS: 'Payment Updates',
    SUBSCRIPTION: 'Subscription Status Changes',
    WORKOUTS: 'Workout Completions',
    HABITS: 'Habit Submissions',
  },
  workoutComplete: 'Completed workout: “{workoutName}” assigned for {assignDate}',
  checkInSubmit: 'Submitted check-in for {weekText} {year}',
  failPayment: 'Payment of {currency}{amount} failed for the invoice “{invoice}”',
  paymentFailReason: '(Reason: {reason})',
  refundPayment: 'Refunded {currency}{amount} payment for the invoice “{invoice}”',
  successPayment: 'Payment of {currency}{amount} paid for the invoice “{invoice}”',
  habitCheckedOff: 'Completed habit(s): {habits} for the {weekText} {year}',
  send: 'Send',
  received: 'Received',
  message: '{msgType} a lead message: {message} ({time})',
  postPaymentForSubmit: 'Submitted post-payment form at {time}',
  signUp: 'Signed up at {time}',
  statusChange: '{type} status changed to {status}',
  callPlaced: 'Call placed by {userName}',
  lead: 'Lead',
  subscription: 'Subscription',
  filterLabel: 'Filter activity',
  emptyText: 'No "{filter}" history data to show for this client',
  empty: '',
  pausedDetails: 'Paused by: {userName}  •  Resumes at: {pauseEnd}',
  unpauseDetails: 'Unpaused by: {userName}',
};

export default texts;
